import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  Multimedia,
  MultimediaThumbnailVariant,
  MultimediaTileComponent,
  MultimediaTileThumbnailComponent,
  PublicShopFilePreviewUrlPipe,
  PublicShopFileThumbnailUrlPipe,
} from '@web/shared/module/multimedia';
import { isNotNil } from '@web/utils';
import { GalleriaModule } from 'primeng/galleria';
import { ImageThumbnailComponent } from '@web/shared/ui';

@Component({
  selector: 'app-public-product-images-galleria',
  imports: [
    GalleriaModule,
    ImageThumbnailComponent,
    MultimediaTileComponent,
    MultimediaTileThumbnailComponent,
    NgOptimizedImage,
    PublicShopFilePreviewUrlPipe,
    PublicShopFileThumbnailUrlPipe,
  ],
  templateUrl: './public-product-images-galleria.component.html',
  styleUrl: './public-product-images-galleria.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductImagesGalleriaComponent {
  public readonly files = input.required<Multimedia[]>();

  protected readonly selected = this.selectedSignal();
  protected readonly shouldShowThumbnails = this.shouldShowThumbnailsSignal();
  protected readonly isNotNil = isNotNil;
  protected readonly Large = MultimediaThumbnailVariant.Large;

  protected activeIndex = 0;
  protected displayFullScreenGalleria = false;

  public handleSelectClickEvent(index: number): void {
    const files = this.files();
    const file = files[index];

    this.selected.set({ file, index });
  }

  public handlePreviewClickEvent(index: number): void {
    this.activeIndex = index;
    this.displayFullScreenGalleria = true;
  }

  private selectedSignal(): WritableSignal<{
    file: Multimedia;
    index: number;
  }> {
    const index = 0;

    return linkedSignal({
      source: this.files,
      computation: ([file]) => ({ file, index }),
    });
  }

  private shouldShowThumbnailsSignal(): Signal<boolean> {
    return computed(() => this.files().length > 1);
  }
}
